import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
export default css `
    ${componentStyles}
    :host {
        display: inline-block;
    }
    .tag {
        background-color: var(--mode-color);
        border-color: var(--mode-color);
        font-family: var(--sgdf-input-font-family);
        font-weight: var(--sgdf-font-weight-semibold);
        border-width: var(--sgdf-input-border-width);
        color: #fff;
        display: flex;
        align-items: center;
        border: solid 1px;
        line-height: 1;
        white-space: nowrap;
        user-select: none;
        cursor: default;
    }

    .outlined {
        background-color: #fff;
        color: var(--mode-color);
        border-color: var(--border-color, --mode-color);
    }

    .tag__remove::part(base) {
        color: inherit;
        padding: 0;
    }

    /*
   * Size modifiers
   */
    .tag--small {
        font-size: var(--sgdf-button-font-size-small);
        height: calc(var(--sgdf-input-height-small) * 0.8);
        line-height: calc(
            var(--sgdf-input-height-small) - var(--sgdf-input-border-width) * 2
        );
        border-radius: var(--sgdf-input-border-radius-small);
        padding: 0 var(--sgdf-spacing-x-small);
    }
    .tag--small .tag__remove {
        margin-left: var(--sgdf-spacing-2x-small);
        margin-right: calc(-1 * var(--sgdf-spacing-3x-small));
        font-size: var(--sgdf-font-size-2x-small);
    }
    .tag--medium {
        font-size: var(--sgdf-button-font-size-medium);
        height: calc(var(--sgdf-input-height-medium) * 0.8);
        line-height: calc(
            var(--sgdf-input-height-medium) - var(--sgdf-input-border-width) * 2
        );
        border-radius: var(--sgdf-input-border-radius-medium);
        padding: 0 var(--sgdf-spacing-small);
    }
    .tag--medium .tag__remove {
        margin-left: var(--sgdf-spacing-2x-small);
        margin-right: calc(-1 * var(--sgdf-spacing-2x-small));
        font-size: var(--sgdf-font-size-x-small);
    }
    .tag--large {
        font-size: var(--sgdf-button-font-size-large);
        height: calc(var(--sgdf-input-height-large) * 0.8);
        line-height: calc(
            var(--sgdf-input-height-large) - var(--sgdf-input-border-width) * 2
        );
        border-radius: var(--sgdf-input-border-radius-large);
        padding: 0 var(--sgdf-spacing-medium);
    }
    .tag--large .tag__remove {
        margin-left: var(--sgdf-spacing-2x-small);
        margin-right: calc(-1 * var(--sgdf-spacing-2x-small));
        font-size: var(--sgdf-font-size-small);
    }
    /*
   * Pill modifier
   */
    .tag--pill {
        border-radius: var(--sgdf-border-radius-pill);
    }
`;
//# sourceMappingURL=tag.styles.js.map